module.exports = __webpack_public_path__ + "static/media/Networth3.d64e139e.png";